export default __webpack_public_path__ + "static/media/flow_3.b2b7a324.jpg";